import { ReactNode } from "react";
import { Sidebar } from "@/components/ui/sidebar/sidebar";
import { RootLayout } from "@/components/layouts";

/* Prop Types */
interface LayoutProps {
  children: ReactNode;
}

/*
 * ProjectsLayout component
 * This layout wraps the projects pages in the application
 */
export const ProjectsLayout = ({ children }: LayoutProps) => {
  /* Render */
  return (
    <RootLayout>
      <div className="grow flex flex-row gap-7">
        {/* Sidebar */}
        <Sidebar />

        {/* Content */}
        <div className="grow flex flex-col gap-4">{children}</div>
      </div>
    </RootLayout>
  );
};
